// Веб-аналитика Umami: посетители, источники и страницы без cookies. Включается, только если при
// сборке задан VITE_UMAMI_WEBSITE_ID. Скрипт и сбор событий идут через наш nginx (/p/, см.
// deploy/nginx/prod.conf.template); «Do Not Track» браузера соблюдается.
//
// Перед отправкой (`data-before-send`) из адреса страницы убираются все параметры, кроме меток
// ссылки `utm_*`, — по ним дашборд делит посетителей по источникам; от сайта-источника остаётся
// только домен, а возврат со входа Steam (`isSteamLoginReturn` фичи `auth`) источником не считается.

import { isSteamLoginReturn } from "@/features/auth";

type UmamiPayload = { url?: string; referrer?: string } & Record<string, unknown>;

const BEFORE_SEND = "__relockUmamiBeforeSend";

const onlyUtm = (raw: string): string => {
  try {
    const url = new URL(raw, window.location.origin);
    for (const key of [...url.searchParams.keys()]) {
      if (!key.startsWith("utm_")) {
        url.searchParams.delete(key);
      }
    }
    url.hash = "";
    return url.toString();
  } catch {
    return raw;
  }
};

const referrerDomain = (raw: string): string => {
  try {
    const url = new URL(raw, window.location.origin);
    if (isSteamLoginReturn(url)) {
      return "";
    }
    return url.origin === window.location.origin ? url.pathname : `${url.origin}/`;
  } catch {
    return "";
  }
};

export const sanitizeUmamiPayload = (_type: string, payload: UmamiPayload): UmamiPayload => ({
  ...payload,
  ...(payload.url === undefined ? {} : { url: onlyUtm(payload.url) }),
  ...(payload.referrer === undefined ? {} : { referrer: referrerDomain(payload.referrer) }),
});

export const initAnalytics = (): void => {
  const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
  if (!websiteId) {
    return;
  }
  Object.assign(window, { [BEFORE_SEND]: sanitizeUmamiPayload });
  const script = document.createElement("script");
  script.defer = true;
  script.src = "/p/script.js";
  script.dataset.websiteId = websiteId;
  script.dataset.hostUrl = `${window.location.origin}/p`;
  script.dataset.beforeSend = BEFORE_SEND;
  script.dataset.doNotTrack = "true";
  document.head.append(script);
};
